import React from 'react';

import { isIOSDevice } from '../lib/platform';
import { cn } from '../lib/utils';

import IdleLogo from '../../assets/images/idle-logo.svg';

import Flexicon from './shared/Flexicon';

const SHARED_PAGE_FOOTER_BUTTON_BASE =
  'flex h-12 cursor-pointer items-center justify-center rounded-[10px] bg-[#08f] px-4 text-[15px] leading-5 font-normal text-white hover:bg-[#0077df] disabled:cursor-not-allowed disabled:opacity-60';

const SharedPageFooterButton = ({ className, type = 'button', children, ...rest }) => (
  <button type={type} className={cn(SHARED_PAGE_FOOTER_BUTTON_BASE, className)} {...rest}>
    {children}
  </button>
);

const SharedPageFooter = ({ workspace, mode, onLoginClick, onJoinClick }) => {
  if (!workspace) return null;

  const buttonHandler = mode === 'join' ? onJoinClick : onLoginClick;
  // "Open in App" only where the tap actually hands off to the app: signed-out
  // visitors on iOS. Signed-in viewers web-join, and other platforms go to the
  // web login flow.
  const buttonLabel = mode !== 'join' && isIOSDevice() ? 'Open in App' : 'Join';

  return (
    <footer className="flex w-full shrink-0 flex-col items-stretch overflow-hidden rounded-2xl border-[0.5px] border-white bg-gray-200 px-[18px] pt-6 pb-[18px] md:h-20 md:flex-row md:items-center md:justify-between md:gap-6 md:border-white/80 md:py-0 md:pr-4 md:pl-6">
      <div className="flex min-w-0 flex-col items-center gap-7 md:flex-row md:gap-6">
        <div className="hidden shrink-0 items-center gap-6 md:flex">
          <IdleLogo aria-hidden="true" focusable="false" className="h-[23px] w-[57px] text-black" />
          <span aria-hidden="true" className="h-12 w-px bg-gray-300" />
        </div>

        <div className="flex min-w-0 flex-col items-center gap-5 md:flex-row md:gap-3">
          <span className="inline-flex size-[120px] shrink-0 md:hidden">
            <Flexicon resource={workspace} size="size-[120px]" rounded="rounded-2xl" />
          </span>
          <span className="hidden size-12 shrink-0 md:inline-flex">
            <Flexicon resource={workspace} size="size-12" rounded="rounded-lg" />
          </span>

          <div className="flex w-[179px] min-w-0 flex-col items-center gap-2.5 text-center md:items-start md:text-left">
            <span className="-my-1 w-full truncate text-xs leading-5 font-light text-gray-500">You&rsquo;re invited to</span>
            <span className="-my-1 w-full truncate text-base leading-5 font-medium text-black">{workspace.title || 'Untitled'}</span>
          </div>
        </div>
      </div>

      <SharedPageFooterButton onClick={buttonHandler} className="mt-7 w-full md:mt-0 md:w-[127px] md:shrink-0">
        {buttonLabel}
      </SharedPageFooterButton>
    </footer>
  );
};

export default SharedPageFooter;
